<template>
    <div class="bookList-main">
            <div class="bookStack-main-header">
                <div class="bookStack-main-header-info">
                    <img v-if="!bookInfo.cover" src="@/assets/img/cmb_book_cover.png" alt="">
                    <img v-else :src="bookInfo.cover" alt="">
                    <div class="bookStack-info">
                        <div class="bookStack-title">
                            <h4>{{$t('content.books.groupName')}}：{{bookInfo ? bookInfo.name : $t('commonMsg.none')}}</h4>
                        </div>
                        <p class="bookStack-count">
                             {{$t('content.books.bookCount')}}：{{bookInfo?bookInfo.booksTotal : 0}}
                        </p>
                        <p class="bookStack-count">
                            {{$t('content.books.channelName')}}： <span v-for="(item, index) in bookInfo.ancestorts" :key="item.id">{{item.name}}{{bookInfo.ancestorts.length - 1 !== index ? '、' : ''}}</span>
                        </p>
                        <p class="bookStack-count">
                             {{$t('content.books.relate')}}：{{bookInfo.orgs?bookInfo.orgs.length : 0}}
                        </p>
                    </div>
                </div>
                <div class="bookStack-btn" v-if="!selectCtrl">
                    <div class="bookStack-btn-edit" >
                        <button :disabled="!Object.keys(bookInfo).length" :class="{'disbaledBtn': !Object.keys(bookInfo).length}" class="global-button-style" @click.stop="editBookList">{{$t('commonMsg.edit')}}</button>
                        <!-- <button class="global-button-style" @click.stop="timing">{{$t('commonMsg.release')}}</button> -->
                    </div>
                    <div>
                        <button :disabled="!Object.keys(bookInfo).length" :class="{'disbaledBtn': !Object.keys(bookInfo).length}" class="global-button-style" @click="addBook">{{$t('content.books.addBook')}}</button>
                        <button :disabled="!Object.keys(bookInfo).length" :class="{'disbaledBtn': !Object.keys(bookInfo).length}" class="global-button-style"  @click.stop="manageBook">{{$t('commonMsg.manage')}}</button>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    props: {
        bookInfo: {
            type:Object
        },
        ancestorts: {
            type:Array
        },
        selectCtrl:{
            type: Boolean,
        }
    },
    data() {
        return {
            isSelect: false,
        }
    },
    methods: {
        // 编辑书单信息
        editBookList() {
            this.$emit('editBookList')
        },
        // 发布
        publish() {
            this.$emit('publish')
        },
        // 定时发布
        timing() {
            this.$emit('timing')
        },
        // 书籍添加
        addBook() {
            this.$emit('addBook')
        },
        // 书本管理
        manageBook() {
            this.isSelect=true;
            this.$emit('manageBook',this.isSelect,'handle')
        },
        // 书本导入
        importBook() {
            this.$emit('importBook')

        },
    }
}
</script>

<style lang="scss" scoped>
    .bookList-main{
        .bookStack-main-header{
            display: flex;
            padding:10px 20px 20px;
            border-bottom: 1px solid $globalBorderColor;
            justify-content: space-between;
            .bookStack-main-header-info{
                display: flex;
                >img{
                    width:100px;
                    height:120px;
                }
                >.bookStack-info{
                    flex:1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    margin-left:30px;
                    .bookStack-title{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        >i{
                            width: 26px;
                            height: 28px;
                            display: inline-block;
                            background: url('~@//assets/img/cmb_edit.png') center no-repeat;
                            background-size: 100% 100%;
                            cursor: pointer;
                        }
                    }
                }
            }

        }
        .bookStack-btn{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .bookStack-btn-edit{
                text-align: right;
            }
            .disbaledBtn{
                background:#ccc;
                cursor: not-allowed;
            }
        }
    }
</style>

